import { render, staticRenderFns } from "./CHADS2ScoreForStrokeRisk.vue?vue&type=template&id=494efb5c&scoped=true&"
import script from "./CHADS2ScoreForStrokeRisk.vue?vue&type=script&lang=js&"
export * from "./CHADS2ScoreForStrokeRisk.vue?vue&type=script&lang=js&"
import style0 from "./CHADS2ScoreForStrokeRisk.vue?vue&type=style&index=0&id=494efb5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494efb5c",
  null
  
)

export default component.exports